import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AdminProfileForm from './admin/AdminProfileForm';
import StudentManagementForm from './admin/StudentManagementForm';
import FillStudentDataButton from './admin/FillStudentDataButton';

const AdminProfileManager: React.FC = () => {
  const { t } = useTranslation(['admin', 'common']);
  const [activeTab, setActiveTab] = useState("profile");
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="space-y-3 sm:space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 h-auto">
          <TabsTrigger value="profile" className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 text-xs sm:text-sm">
            <User className="h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">{t('admin:adminProfile')}</span>
            <span className="sm:hidden">{t("common:profile")}</span>
          </TabsTrigger>
          <TabsTrigger value="students" className="flex items-center gap-1 sm:gap-2 px-2 sm:px-4 py-2 text-xs sm:text-sm">
            <User className="h-3 w-3 sm:h-4 sm:w-4" />
            <span className="hidden sm:inline">{t('admin:studentManagement')}</span>
            <span className="sm:hidden">{t('admin:students')}</span>
          </TabsTrigger>
        </TabsList>
        <TabsContent value="profile" className="space-y-3 sm:space-y-6 mt-3 sm:mt-6">
          <AdminProfileForm isLoading={isLoading} setIsLoading={setIsLoading} />
        </TabsContent>

        <TabsContent value="students" className="space-y-3 sm:space-y-6 mt-3 sm:mt-6">
          <div className="space-y-3 sm:space-y-6">
            <StudentManagementForm />
            <FillStudentDataButton />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminProfileManager;
